import { render, staticRenderFns } from "./UnderConstruction.vue?vue&type=template&id=1c276a5c&"
import script from "./UnderConstruction.vue?vue&type=script&lang=js&"
export * from "./UnderConstruction.vue?vue&type=script&lang=js&"
import style0 from "./UnderConstruction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VImg,VRow})
